module.exports = __webpack_public_path__ + "img/apple.22f8fdd.png";